import { makeEndpointFns } from '../fns';
import { CgHierarchyHeader, CgMetadata, CgNetwork, CommodityGroup } from '@whiz-cart/node-shared/models/commodityGroup/commodityGroup';
import { CommodityGroupMergedQuery } from '@whiz-cart/node-shared/models/commodityGroup/commodityGroupMergedQuery';
import z from 'zod';

const { GET, POST } = makeEndpointFns('storeManager');

export const commodityGroups = {
    /** Returns merged commodity groups for a specific inventory management system */
    cgImsMerged: GET('api/v1/commoditygroup/merged/{inventoryManagementSystem}', CommodityGroup.array(), {
        query: CommodityGroupMergedQuery,
    }),
    /** Returns only one merged commodity group and all its children for a specific inventory management system */
    cgImsMergedPartial: GET('api/v1/commoditygroup/merged/{inventoryManagementSystem}/withChildren/{fullId}', CommodityGroup.array(), {
        query: CommodityGroupMergedQuery,
    }),

    /** Returns merged commodity groups for a specific store */
    cgStoreMerged: GET('api/v1/commoditygroup/{storeGuid}/merged', CommodityGroup.array(), { query: CommodityGroupMergedQuery }),
    /** Returns only the root merged commodity groups for a specific store */
    cgStoreMergedRoots: GET('api/v1/commoditygroup/{storeGuid}/merged/roots', CommodityGroup.array(), {
        query: CommodityGroupMergedQuery,
    }),
    /** Returns only the leaf merged commodity groups for a specific store */
    cgStoreMergedLeaves: GET('api/v1/commoditygroup/{storeGuid}/merged/leaves', CommodityGroup.array(), {
        query: CommodityGroupMergedQuery,
    }),
    /** Returns only one merged commodity group and all its children for a specific store */
    cgStoreMergedPartial: GET('api/v1/commoditygroup/{storeGuid}/merged/withChildren/{fullId}', CommodityGroup.array(), {
        query: CommodityGroupMergedQuery,
    }),

    /** Returns all inventory management systems that have commodity groups */
    getInventoryManagementSystems: GET('api/v1/commoditygroup/ims', z.record(z.string(), z.number())),
    /** Returns all commodity group hierarchy headers */
    getCgHierarchyHeaders: GET('api/v1/commoditygroup/hierarchy/headers', CgHierarchyHeader.array()),

    /** Sets the labels for a specific commodity group in an inventory management system */
    setLabels: POST(
        'api/v1/commoditygroup/hierarchy/labels/{fullId}?inventoryManagementSystem={inventoryManagementSystem}',
        CommodityGroup,
        { body: z.string().array() },
    ),

    /** Sets the classification networks for a specific commodity group in an inventory management system */
    setClassificationNetworks: POST(
        'api/v1/commoditygroup/hierarchy/classificationNetworks/{fullId}?inventoryManagementSystem={inventoryManagementSystem}',
        CommodityGroup,
        { body: z.record(z.string(), CgNetwork) },
    ),

    /** Updates the metadata for a specific commodity group in an inventory management system */
    cgImsUpdateMetadata: POST(
        'api/v1/commoditygroup/hierarchy/metadata/{fullId}?inventoryManagementSystem={inventoryManagementSystem}',
        CommodityGroup,
        { body: CgMetadata },
    ),

    /** Updates the metadata for a specific commodity group in a store */
    cgStoreUpdateMetadata: POST('api/v1/commoditygroup/{storeGuid}/hierarchy/metadata/{fullId}/store', CommodityGroup, {
        body: CgMetadata,
    }),
};
